export default function XSD_Any() {
  return (
    <div>
      <h1>XSD_Any</h1>
      <p>This is the XSD_Any component.</p>
    </div>
  );
}